(function () {
    var cookiePolicyPopupWidget = {
        $element: $('.cookiePolicy-popup'),
        acceptUrl: '/action/cookiePolicy?response=accept',

        init: function () {
            cookiePolicyPopupWidget.control();
        },
        control: function () {
            cookiePolicyPopupWidget.additionalControl();

            cookiePolicyPopupWidget.$element.on(
                'click',
                '.cookiePolicy-popup__close, #accept-cookie-policy',
                function (e) {
                    e.preventDefault();

                    $.get(cookiePolicyPopupWidget.acceptUrl, function () {
                        console.log('Cookies Accepted!');
                    });
                    cookiePolicyPopupWidget.$element.slideUp('fast', function () {
                        cookiePolicyPopupWidget.$element.remove();
                        cookiePolicyPopupWidget.cookieRemoved();
                        // @TODO: This fix is to be removed after the fix that Haitham Athamneh will apply
                        if (UX.coolbar) {
                            UX.coolbar.headerHeight = $('header').outerHeight() || 0;
                            $('.coolBar--res').addClass('trans').css('top', UX.coolbar.headerHeight);
                        }
                        if (UX.pageBody && UX.pageBody.on && UX.pageBody.on.setContentTopPadding) {
                            UX.pageBody.on.setContentTopPadding(true);
                        }
                    });
                }
            );
        },
        cookieRemoved: function () {},
        additionalControl: function () {},
    };
    UX.cookiePolicyPopupWidget = cookiePolicyPopupWidget;
})();
